import { get } from 'lodash';
import { useI18n } from 'vue-i18n';

export function useInternationalization(localizationKey) {
  const i18n = useI18n({ useScope: 'global' });

  const tkey = (key, ...args) => {
    let translation;
    if (!localizationKey) {
      translation = i18n.t(key, ...args);
    } else {
      translation = i18n.t(`${localizationKey}.${key}`, ...args);
    }

    // If translation fails check if last argument is an option object with a fallback
    if (translation === key || translation === `${localizationKey}.${key}`) {
      return get(args.pop(), 'fallback', translation);
    }

    return translation;
  };

  const normalizeTranslation = (key, tc) => tc(key);

  return {
    t: i18n.t,
    tkey,
    normalizeTranslation,
  };
}
